import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { splitPhone } from "@/lib/phone_split";
import PhonePrefixInput from "@/components/PhonePrefixInput";

export default function WhatsAppPreferencesCard({ user, refresh }) {
  const initial = splitPhone(user.phone || "", user.phone_prefix || "+41");
  const [number, setNumber] = useState(initial.number);
  const [prefix, setPrefix] = useState(initial.prefix);
  const [consent, setConsent] = useState(Boolean(user.whatsapp_opt_in));
  const [available, setAvailable] = useState(false);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    let active = true;
    api.get("/whatsapp/availability").then(({ data }) => {
      if (active) setAvailable(data.available === true);
    }).catch(() => {});
    return () => { active = false; };
  }, []);
  useEffect(() => {
    const current = splitPhone(user.phone || "", user.phone_prefix || "+41");
    setNumber(current.number); setPrefix(current.prefix);
    setConsent(Boolean(user.whatsapp_opt_in));
  }, [user.phone, user.phone_prefix, user.whatsapp_opt_in]);
  const save = async (event) => {
    event.preventDefault(); setSaving(true);
    try {
      await api.patch("/auth/profile", { phone: number, phone_prefix: prefix, whatsapp_opt_in: consent });
      await refresh();
      toast.success(consent ? "Preferenza WhatsApp salvata" : "Aggiornamenti WhatsApp disattivati");
    } catch (error) {
      toast.error(formatApiError(error.response?.data?.detail) || "Impossibile salvare la preferenza");
    } finally { setSaving(false); }
  };
  return (
    <form onSubmit={save} className="card-soft p-6 space-y-4 min-w-0" data-testid="whatsapp-preferences">
      <h2 className="font-display text-lg font-bold">Aggiornamenti WhatsApp</h2>
      {!available && <p className="text-sm text-amber-800">Servizio in preparazione: puoi salvare la preferenza, ma gli aggiornamenti WhatsApp non sono ancora attivi.</p>}
      <PhonePrefixInput label="Il tuo numero di telefono" testidPrefix="whatsapp-phone" prefix={prefix}
        onPrefixChange={(value) => { setPrefix(value); setConsent(false); }} number={number}
        onNumberChange={(value) => { setNumber(value); setConsent(false); }} />
      <label className="flex items-start gap-3 text-sm cursor-pointer">
        <input type="checkbox" checked={consent} onChange={(event) => setConsent(event.target.checked)}
          data-testid="whatsapp-consent" className="mt-1 h-5 w-5 shrink-0" />
        <span>Desidero ricevere da DapNow gli aggiornamenti sulle mie spedizioni via WhatsApp al mio numero indicato sopra. Nessun messaggio promozionale. Posso revocare questa scelta qui o rispondendo STOP.</span>
      </label>
      <p className="text-xs text-dapnow-muted">Facoltativo. Lo stato delle spedizioni resta disponibile nell’app. Il consenso riguarda il tuo numero, non quello del destinatario del pacco.</p>
      <button type="submit" disabled={saving} className="btn-primary" data-testid="whatsapp-preferences-save">{saving ? "Salvataggio…" : "Salva preferenza"}</button>
    </form>
  );
}
